import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveTerm() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((formData) => {
    setSaving(true);
    return quarkusApi
      .post('/terms', formData, { headers: { Authorization: sessionStorage.getItem('token') } })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
